<template>
  <div id="app">
    <router-view></router-view>
    <a
      href="https://wa.me/5491123697583?text=¡Hola! Necesito ayuda con mi cotizacion"
      target="_blank"
    >
      <img src="https://d23e8pcs5gsiak.cloudfront.net/static/images/whatsap2.svg" alt />
    </a>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
@media screen and (max-width: 450px) {
  #intercom-container {
    display: none;
  }
}
</style>

<style scoped lang="scss">
a {
  position: fixed;
  width: 60px;
  height: 60px;
  left: 20px;
  bottom: 20px;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/App.vue